import {Component, OnInit} from '@angular/core';
import {MediatorService} from '../services/mediator.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public mediator: MediatorService) {
  }

  ngOnInit(): void {
  }

}
